import { ReactNode } from 'react';
import { Center } from '@/components/ui/layout';
import { AuthBackground } from './components/AuthBackground';
import { AuthHeader } from './components/AuthHeader';
import { AuthCard } from './components/AuthCard';
import { AuthFooter } from './components/AuthFooter';

export interface AuthLayoutProps {
  children: ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
  showBackButton?: boolean;
  backTo?: string;
}

export function AuthLayout({
  children,
  showHeader = true,
  showFooter = true,
  showBackButton = false,
  backTo = '/auth/login'
}: AuthLayoutProps) {
  return (
    <AuthBackground variant="auth">
      {showHeader && <AuthHeader showThemeToggle showBackButton={showBackButton} backTo={backTo} />}
      <Center mih="100vh" p="md">
        <AuthCard>
          {children}
        </AuthCard>
      </Center>
      {showFooter && <AuthFooter />}
    </AuthBackground>
  );
}

export default AuthLayout;
